import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * Pickery antd v5 (DatePicker/RangePicker) działają na dayjs — obiektach niemutowalnych.
 * Obiekt moment mutuje się w miejscu, więc rc-picker budując siatkę kalendarza
 * (addDate(baseDate, offset) dla 42 komórek) kumuluje przesunięcia i daty uciekają o lata.
 * Każda wartość podawana do pickera musi więc przejść przez ten helper.
 */
export const toPickerDate = (value, format) => {
  if (value === null || value === undefined || value === '') return null;

  const date = format ? dayjs(value, format) : dayjs(value);
  return date.isValid() ? date : null;
};

/** Czy wartość z formularza jest datą pickera (dayjs), a nie stringiem/moment. */
export const isPickerDate = (value) => dayjs.isDayjs(value) && value.isValid();
